// DP-3115: shared tooltip copy for the standalone "Both" stop type, used by the ETA Notifications
// and Colorized Indicators stop-type selectors. Rendered as the CONTENT of a Blueprint Tooltip that
// wraps the "Both" option row itself (no info icon). The last phrase renders italic per the ticket.
export const BOTH_STOP_TOOLTIP = (
  <>
    &quot;Both&quot; stops in this context means there&apos;s a pickup AND a delivery at the stop. This does not mean{" "}
    <em>both types of stops</em>.
  </>
);
